/* esm.sh - suspend-react@0.1.3 */
export * from "/*suspend-react@0.1.3/esnext/suspend-react.mjs";
